import CreateNewChatModal from './CreateNewChatModal';

export default CreateNewChatModal;